import { useEffect } from 'react'
import { C, grad, CAL, APP_SIGNIN, APP_SIGNUP } from '../components/shared'

/*
 * /signup (Launch fixes 1, 2026-10-19). Launch fixes 3 (the PM's decision 5, 2026-10-26): the visitor always goes to the
 * app's signup page, which follows the app's one switch ("SerpDesk is opening soon" with the demo link while signup is
 * closed, the form once it is open). The links below show only for the moment before the page moves on.
 */
export default function SignupSoonPage() {
  useEffect(() => {
    document.title = 'Start a free trial | SerpDesk'
    window.location.replace(APP_SIGNUP)
  }, [])
  return (
    <section style={{ background: C.hero, color: '#fff', paddingTop: 140, paddingBottom: 96, minHeight: '60vh' }}>
      <div style={{ maxWidth: 640, margin: '0 auto', padding: '0 24px', textAlign: 'center' }}>
        <h1 style={{ fontFamily: 'var(--display)', fontSize: 'clamp(30px, 5vw, 44px)', fontWeight: 800, letterSpacing: '-.03em', margin: 0 }}>Start a free trial</h1>
        <p style={{ fontSize: 16, color: 'rgba(255,255,255,.6)', lineHeight: 1.65, margin: '16px 0 28px' }}>
          Opening the signup page in the app: <a href={APP_SIGNUP} style={{ color: '#c4b5fd' }}>app.serpdesk.ai/api/signup</a>.
        </p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, justifyContent: 'center', alignItems: 'center' }}>
          <a href={CAL} target="_blank" rel="noopener noreferrer" style={{ fontSize: 14, fontWeight: 700, color: '#fff', padding: '11px 24px', borderRadius: 10, background: grad, textDecoration: 'none' }}>Book a Preloaded Demo →</a>
        </div>
        <p style={{ fontSize: 13.5, color: 'rgba(255,255,255,.45)', marginTop: 28 }}>
          Already have an account? <a href={APP_SIGNIN} style={{ color: '#c4b5fd' }}>Sign in</a>. See <a href="/pricing" style={{ color: '#c4b5fd' }}>pricing</a>.
        </p>
      </div>
    </section>
  )
}
